/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

import Image from "next/image";
import Link from "next/link";
import Demoimg from "@/public/static/images/demo_img.png";

import DigitalMarketing from "@/public/static/images/1_thumbnail_digital-marketing.jpg";
import EventActivation from "@/public/static/images/2_thumbnail_event-&-activation.jpg";
import WebsiteApplication from "@/public/static/images/3_thumbnail_website-&-application.jpg";
import GraphicDesign from "@/public/static/images/4_thumbnail_graphic-design-2d-&-3d.jpg";
import SalesPromotion from "@/public/static/images/5_thumbnail_sales-promotion-tools.jpg";
import Localization from "@/public/static/images/6_thumbnail_localization.jpg";
import PrintingLogistics from "@/public/static/images/7_thumbnail_printing-&-logistics.jpg";
import TrainingTools from "@/public/static/images/8_thumbnail_training-tools.jpg";
import Ecommerce from "@/public/static/images/9_thumbnail_e-commerce.jpg";
import { useRouter } from "next/router";
import { getNews } from "@/features/admin/news";
import { appDispatch, appSelector } from "@/store/hooks";
import filter, { convertDate, filterDetail } from "@/features/news";

function news_detail() {
  const router = useRouter();
  let { id, lang }: any = router.query;
  if (!lang) {
    lang = "English";
  }
  const dispatch = appDispatch();
  const { data } = appSelector((state) => state.news);
  let currentData = [];
  let rows: any = {
    news_id: "",
    thumbnail: "",
    topic: "",
    status: "",
    category: "",
    service: "",
    short_description: "",
    detail: "",
    post_date: "",
  };
  if (id) {
    if (data.length > 0) {
      rows = filterDetail(data, id[0], lang);
      currentData = filter(data, lang, "All", "All");
    }
  }
  useEffect(() => {
    dispatch(getNews(""));
  }, [dispatch]);

  return (
    <div className="wrapper">
      <Header />
      <section className="black-content sv_content news_content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-start news_content-heading">
              <h1 className="lh-1 t-white fw-bolder mb-0">{rows.topic}</h1>
              <p className="t-white">Posted on {rows.post_date}</p>
              <Stack spacing={1} alignItems="left">
                <Stack direction="row" spacing={1}>
                  <Chip label={rows.category} className="categorize_s" />
                  <Chip label={rows.service} className="categorize_c" />
                </Stack>
              </Stack>
            </div>
          </div>
        </div>
      </section>
      <section className="gray-content sv_content">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-9 news_content-detail">
              <p
                dangerouslySetInnerHTML={{
                  __html: rows.detail ? rows.detail : "",
                }}
              ></p>
            </div>
            <div className="col-12 col-md-3">
              <div className="row">
                <div className="col-12 mb-4">
                  <div className="sub-heading">
                    <h2 className="fw-bolder">You may also like this</h2>
                  </div>
                </div>
                {currentData.length > 0 &&
                  currentData.map((value: any, key: any) => {
                    if (value.status == "Publish") {
                      return (
                        <div key={key} className="col-12 zoom">
                          <Link
                            href={{
                              pathname: `/news/${value.news_id}/${value.topic}`,
                              query: { lang: lang },
                            }}
                          >
                            <div className="card h-100">
                              <div className="img-card">
                                <Image
                                  loading="lazy"
                                  unoptimized
                                  src={value.thumbnail}
                                  alt={value.topic}
                                  className="h-100 w-100 object-fit-contain"
                                  width={500}
                                  height={300}
                                />
                              </div>

                              <div className="card-body">
                                <h3 className="card-title mb-0 text-truncate">
                                  {value.topic}
                                </h3>
                                <p className="date mb-2">{value.post_date}</p>
                                <Stack spacing={1} alignItems="left">
                                  <Stack direction="row" spacing={1}>
                                    <Chip
                                      label={value.category}
                                      className="categorize_s mb-3"
                                    />
                                    <Chip
                                      label={value.service}
                                      className="categorize_c mb-3"
                                    />
                                  </Stack>
                                </Stack>
                                <p className="card-text">
                                  {value.short_description}
                                </p>
                              </div>
                            </div>
                          </Link>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  })}

                {/* <div className="col zoom">
                  <Link href={"news/newsdetail"}>
                    <div className="card h-100">
                      <div className="img-card">
                        <Image loading="lazy"
                          src={DigitalMarketing}
                          alt="Our Project"
                          className="h-auto w-100"
                        />
                      </div>

                      <div className="card-body">
                        <h3 className="card-title mb-0 text-truncate">
                          Headline
                        </h3>
                        <p className="date mb-2">23 Jan 2023</p>
                        <Stack spacing={1} alignItems="left">
                          <Stack direction="row" spacing={1}>
                            <Chip label="News" className="categorize_s mb-3" />
                            <Chip
                              label="Digital Marketing"
                              className="categorize_c mb-3"
                            />
                          </Stack>
                        </Stack>
                        <p className="card-text">
                          This is a longer card with supporting text below as a
                          natural lead-in to additional content. This content is
                          a little bit longer.
                        </p>
                      </div>
                    </div>
                  </Link>
                </div> */}
                {/* // */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default news_detail;
